import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import formatPercent from '@/modules/_helpers/formatPercent'

const useStyles = makeStyles((theme) => ({
  percentageCellContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    height: '100%',
    width: '35%',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 20,
  },
  percent: {
    height: 35,
    width: '65%',
    flex: 2,
    color: 'black',
    position: 'relative',
  },
  percentText: {
    height: '100%',
    position: 'absolute',
    display: 'inline-flex',
    alignItems: 'center',
    top: 0,
    right: 10,
  },
  totalPercent: {
    height: '100%',
    backgroundColor: theme.lightBackground,
    borderRadius: 4,
  },
  actualPercent: ({ percentageValue }) => ({
    height: '100%',
    width: `${percentageValue}%`,
    backgroundColor: theme.primaryBright,
    borderRadius: 4,
  }),
}))

const PercentageBarCell = (props) => {
  const { valueFormatted, value, percentageBaseFieldName, data } = props

  const percentageBase = data.percentageBase && percentageBaseFieldName ? data.percentageBase[percentageBaseFieldName] : 0
  const percentageValue = (percentageBase > 0 ? (value / percentageBase) * 100 : 0).toFixed(2)
  const classes = useStyles({ percentageValue })

  if (!percentageBaseFieldName) {
    console.error('No percentageBaseFieldName defined in ListColumnModel for ' + props.data.constructor.name)
    return null
  }

  if (!data.percentageBase) {
    console.error('percentageBase is not defined in ' + props.data.constructor.name)
    return null
  }

  return (
    <div className={classes.percentageCellContainer}>
      <div className={classes.value} >
        {valueFormatted ?? value}
      </div>
      <div className={classes.percent}>
        <div className={classes.totalPercent}>
          <div className={classes.actualPercent}></div>
        </div>
        <span className={classes.percentText}>{formatPercent(percentageValue)}</span>
      </div>
    </div>
  )
}

PercentageBarCell.propTypes = {
  data: PropTypes.object,
}

export default PercentageBarCell
